<template>
  <div class="list-group mt-2">
    <alert-comp :msg="alert" :key="alert.key"/>
    <button
      type="button"
      :class="`disable-cursor list-group-item list-group-item-action ${hover === mensagem.identificador ? 'active' : ''}`"
      v-for="(mensagem, index) in mensagens"
      :key="mensagem.identificador"
      @mouseover="toogle(mensagem)"
      @mouseleave="toogle()"
    >
      <div class="row">
        <div :class="hover === mensagem.identificador ? 'col-8 text-left' : 'col-8 text-left'">
          Usuário Inclusão
          <br>
          <strong>{{ mensagem.executor.titulo }}</strong>
          <br>
          Observação
          <br>
          <strong>{{ mensagem.texto }}</strong>
        </div>
        <div v-if="hover === mensagem.identificador" class="col-4 text-right">
          <span
            class="link"
            v-if="isAtivo(index, mensagem.situacao, mensagem.destino.participantePai.identificador)"
            @click.prevent="inativar(mensagem.identificador)"
          >
            INATIVAR
          </span>
        </div>
        <div v-if="hover !== mensagem.identificador" class="col-4 text-left">
          Data Inclusão: <strong>{{ formatData(mensagem.dataCriacao) }}</strong>
          <br>
          Setor: <strong>{{ mensagem.destino.participantePai.titulo }}</strong>
          <br>
          Situação: <strong>{{ isAtivo(index, mensagem.situacao, mensagem.destino.participantePai.identificador) ? 'Ativo' : 'Inativo' }}</strong>
        </div>
      </div>
    </button>
    <div class="col-12">
      <pagination-comp :pagination="pagination" :eventBusDataPaginationName="eventPagination"/>
    </div>
  </div>
</template>

<script>
import VirtusMensagemService from '@/services/VirtusMensagemService'

import { localDateParse } from '@/uteis/converters/LocalDateConverter'
import eventBus from '@/uteis/eventBus'

import paginationComp from '@/components/pagination/PaginationComp'
import alertComp from '@/components/alert/AlertComp'

import md5 from 'md5'

export default {
  name: 'lista-observacao',
  props: {
    numeroProcesso: { type: String, required: true }
  },

  components: {
    paginationComp,
    alertComp
  },

  data () {
    return {
      hover: '',
      mensagens: [],
      mensagem: {},
      filtro: {
        offset: 1,
        range: 5
      },
      pagination: {
        hasPrev: false,
        hasNext: false,
        totalPage: 0
      },
      eventPagination: 'consultaMensagemPagination',
      alert: {
        texto: '',
        type: ''
      }
    }
  },

  computed: {
    securityKey () {
      const dateNow = new Date()
      return md5(JSON.stringify(this.mensagem) + dateNow.toString())
    }
  },

  methods: {
    pesquisar (page = 1) {
      this.filtro.offset = page
      this.filtro['destino.tipoIdentificador'] = 'NUMERO_PROCESSO'
      this.filtro['destino.identificador'] = this.numeroProcesso

      this.service.getMensagens(this.filtro).then(res => {
        this.mensagens = res.data
        this.pagination = res.pagination
      }).catch(err => {
        console.log(err)
      })
    },

    toogle (mensagem) {
      this.hover = mensagem ? mensagem.identificador : ''
      this.mensagem = mensagem || {}
    },

    isAtivo (index, situacao, departamento) {
      const dadosSessao = this.$store.getters.getDadosSessao.sessao

      return this.filtro.offset === 1 && index === 0 && !situacao && departamento === dadosSessao.idDepartamento.toString()
    },

    inativar (identificador) {
      this.alert.key = !this.alert.key
      this.service.updateMensagem(identificador, {
        situacao: 'Inativo'
      }, this.securityKey).then(res => {
        this.alert.texto = 'Alterado com Sucesso!'
        this.alert.type = 'success'
        this.pesquisar()
      }).catch(err => {
        this.alert.texto = !err.response.data || !err.response.data.message ? 'Aconteceu algo com servidor.' : err.response.data.message
        this.alert.type = 'danger'
      })
    },

    formatData (date) {
      return localDateParse(date).value
    }
  },

  created () {
    this.service = new VirtusMensagemService()
    this.pesquisar()
    eventBus.$on(this.eventPagination, (page) => {
      this.pesquisar(page)
    })
  }
}
</script>
